import { LineItemKindEnum } from '../../../generated/api.graphql';

export const LineItemKind = Object.freeze({
  TICKET: LineItemKindEnum.Ticket,
  ADDON: LineItemKindEnum.Addon,
});
export type LineItemKind = (typeof LineItemKind)[keyof typeof LineItemKind];
